export default __webpack_public_path__ + "static/media/1307.c7084e60.png";